import { AnalisarImagemSkinive, ListarChamadosSkinive } from "@/api/skiniver";
import * as atendimento from "@/api/atendimento";

const createInitialResultado = () => ({
  id: null,
  protocoloANS: "",
  riskLevelTitle: "",
  riskLevel: "",
  risk: "",
  riskTitle: "",
  riskDescription: "",
  riskSuggestion: "",
  disease: "",
  className: "",
  classRaw: "",
  lesionCode: "",
  atlasPageLink: "",
  shortRecommendation: "",
  isResultConfident: true,
  qualityGood: true,
  raw: null
});

// Converte a analise da Skinive (retorno da API) no formato exibido pelas telas.
export const mapearAnalise = (analise = {}) => ({
  riskLevelTitle: analise?.risk_level_title || analise?.risk,
  riskLevel: analise?.risk_level,
  risk: analise?.risk || "",
  riskTitle: analise?.risk_title || "",
  riskDescription: analise?.risk_description || "",
  riskSuggestion: analise?.risk_suggestion || analise?.short_recommendation || "",
  disease: analise?.desease || "",
  className: analise?.class || "",
  classRaw: analise?.class_raw || "",
  lesionCode: analise?.lesion_code || "",
  atlasPageLink: analise?.atlas_page_link || "",
  shortRecommendation: analise?.short_recommendation || "",
  isResultConfident: analise?.is_result_confident ?? true,
  qualityGood: analise?.quality_good ?? true
});

const initialState = () => ({
  chamados: [],
  imageUrl: "",
  uploadMethod: "upload",
  resultado: createInitialResultado(),
  isAnalyzing: false,
  error: null,
  hasImageError: false,
  errorMessage: ""
});

export default {
  namespaced: true,
  state: () => initialState(),
  mutations: {
    SET_CHAMADOS(state, chamados) {
      state.chamados = chamados;
    },
    SET_IMAGE_URL(state, url) {
      state.imageUrl = url;
    },
    SET_UPLOAD_METHOD(state, method) {
      state.uploadMethod = method;
    },
    SET_ANALYSIS_RESULT(state, resultado) {
      state.resultado = resultado;
      state.hasImageError = false;
      state.errorMessage = "";
      state.error = null;
    },
    SET_IS_ANALYZING(state, status) {
      state.isAnalyzing = status;
    },
    SET_ERROR(state, { error, errorMessage, hasImageError }) {
      state.error = error;
      state.errorMessage = errorMessage;
      state.hasImageError = hasImageError;
      state.imageUrl = "";
      state.resultado = createInitialResultado();
    },
    CLEAR_ERROR(state) {
      state.error = null;
      state.hasImageError = false;
      state.errorMessage = "";
    },
    RESET_CONTEXT(state) {
      Object.assign(state, { ...initialState(), chamados: state.chamados });
    },
    LOGOUT_USER(state) {
      Object.assign(state, initialState());
    }
  },
  actions: {
    async listChamados(context) {
      const resp = await ListarChamadosSkinive({
        vinculo: context.rootState.saude?.vinculo
      });
      const chamados = (resp?.Data || []).map(c => ({
        ...c,
        ProtocoloANS: c.ProtocoloANS ? String(c.ProtocoloANS).replace(/\.0+$/, "") : c.ProtocoloANS
      }));
      context.commit("SET_CHAMADOS", chamados);
      return chamados;
    },
    async uploadFile(context, { filename, blobFile }) {
      return await atendimento.FileUpload({
        vinculo: context.rootState.saude?.vinculo,
        filename,
        blobFile
      });
    },
    async analyzeSkiniverImage(context, { urlImagem } = {}) {
      context.commit("SET_IS_ANALYZING", true);
      context.commit("CLEAR_ERROR");
      try {
        const resp = await AnalisarImagemSkinive({
          vinculo: context.rootState.saude?.vinculo,
          UrlImagem: urlImagem || context.state.imageUrl
        });

        if (resp?.Error) {
          throw new Error(resp.Error);
        }

        const data = resp?.Data || resp || {};
        if (data?.Error) {
          throw new Error(data.Error);
        }

        const analise = data?.Analise || data || {};

        const resultado = {
          id: data?.Id || null,
          protocoloANS: data?.ProtocoloANS || "",
          ...mapearAnalise(analise),
          raw: data
        };

        context.commit("SET_ANALYSIS_RESULT", resultado);
        return resp;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.Error ||
          error?.data?.Error ||
          error?.Error ||
          error?.message ||
          "A imagem aparenta ter problemas,\ntente novamente";

        context.commit("SET_ERROR", {
          error,
          errorMessage,
          hasImageError: true
        });
        throw error;
      } finally {
        context.commit("SET_IS_ANALYZING", false);
      }
    }
  }
};
